import { createContext } from 'react';
import {
  MESSAGE,
  EMAIL,
  PRODUCT_TO_BE_ADDED,
  SEND_TO_PS,
  ADD_NOTE,
  DENY,
  EXTENDED_CONSULT,
  STOREFRONT_HISTORY,
  SOAP,
  KIT,
  EXTENDED_FLAG,
  FLAG_INPUTS_V2,
  PRODUCT_TO_BE_CHANGED,
  NOTE_ANALYTICS_BY_ORDER,
  JODIT_EDITOR,
  JODIT_EDITOR_TEMPLATE_FOR_KIT,
  TASK_STATUS,
  VISIT_TYPE,
  JUMP_START_INFO,
} from '../../constants/patientChart.constant';
import { Order, ColumnType } from '../../components/subComponents/table';
import { CRITICAL_FLAG, DOCTOR_FLAG } from '../../constants/visits.constant';

export const PatientChartContext = createContext({
  orderId: 0,
  patientId: 0,

  visitType: VISIT_TYPE.ASYNC,

  ModalCollection: new Map(),
  setModalCollection: () => {},
  handleModalOpen: ({ key = '', modal = {} }) => {},
  handleModalClose: ({ key = '' }) => {},
  handleMultipleModalClose: ({ keys = [] }) => {},

  selectedProducts: new Set(),
  setSelectedProducts: () => {},

  collapsible: new Set(),
  handleExpandMultiple: ({ keys = [] }) => {},
  handleCollapseMultiple: ({ keys = [] }) => {},

  sortBy: {
    key: '',
    type: ColumnType.string,
    order: Order.asc
  },
  setSortBy: () => {},

  tab: '',
  setTab: () => {},

  call: { reason: -1, doctorNumber: '', error: new Map(), roomId: '' },
  setCall: () => {},

  message: MESSAGE(),
  setMessage: () => {},

  email: EMAIL(),
  setEmail: () => {},

  joditEditorTemplate: JODIT_EDITOR(),
  setJoditEditorTemplate: () => {},

  productToBeAdded: PRODUCT_TO_BE_ADDED(),
  setProductToBeAdded: () => {},

  productToBeChanged: PRODUCT_TO_BE_CHANGED(),
  setProductToBeChanged: () => {},

  sendToPS: SEND_TO_PS(),
  setSendToPS: () => {},

  addNote: ADD_NOTE(),
  setAddNote: () => {},

  deny: DENY(),
  setDeny: () => {},

  soap: SOAP(),
  setSoap: () => {},

  taskStatus: TASK_STATUS(),
  setTaskStatus: () => {},

  jumpStart: JUMP_START_INFO(),
  setJumpStart: () => {},

  loading: new Set(['']),
  setLoading: () => {},
  startLoading: (loading = new Set(['']), key = '') => new Set(['']),
  stopLoading: (loading = new Set(['']), key = '') => new Set(['']),

  flag: EXTENDED_FLAG(),
  setFlag: () => {},

  extendedConsult: EXTENDED_CONSULT(),
  setExtendedConsult: () => {},

  storefrontHistory: STOREFRONT_HISTORY(),
  setStorefrontHistory: () => {},

  editableField: new Set(['']),
  setEditableField: () => {},

  kit: KIT(),
  setKit: () => {},

  joditEditorTemplateForKit: JODIT_EDITOR_TEMPLATE_FOR_KIT(),
  setJoditEditorTemplateForKit: () => {},

  pin: '',
  setPin: () => {},

  icd10Code: '',
  setICD10Code: () => {},

  selectedICD10Codes: new Map([
    ['', ''],
  ]),
  setSelectedICD10Codes: () => {},

  removedICD10Codes: new Map([
    ['', {
      Id: 0,
      ICDCode: '',
      ICDDesc: '',
      OrderId: 0,
    }],
  ]),
  setRemovedICD10Codes: () => {},

  noteAnalytics: NOTE_ANALYTICS_BY_ORDER(),
  setNoteAnalytics: () => {},

  orderFlags: FLAG_INPUTS_V2(),
  prescriberFlags: FLAG_INPUTS_V2(),
  doctorFlags: [DOCTOR_FLAG()],
  criticalFlags: [CRITICAL_FLAG()],
  assignedDoctorId: 0,
  isAssignedDoctorViewing: false,
  areFlagsValid: false,
  noOfRequiredFlags: 0,
  noOfAnsweredFlags: 0,

  /**
   * @param {{
   *  pId: number;
   *  isAlternateRx: boolean;
   *  skipCheckingChangeProducts: boolean;
   *  skipCheckingAppSettings: boolean;
   * }}
   * @returns {boolean}
   */
  isConfiguredAlternateRx: ({
    pId,
    isAlternateRx,
    skipCheckingAppSettings,
    skipCheckingChangeProducts,
  }) => false,

  noOfPendingTasks: 0,
  noPendingTask: false,

  /**
   * @param {{
   *  orderId: string | number;
   *  productId: number;
   * }} params 
   * @returns {Promise<{
   *  status: number;
   *  data: {
   *    Data: {
   *      StringValue: string;
   *    };
   *  }
   * }>}
   */
  fetchJumpStartURL: async ({ orderId, productId }) => ({}),

  handleLoadProductsListing: () => {},
  handleHistoryResponse: async () => ({ status: '' }),
  handleLoadHistoryThenProductListing: () => {},
});

export const PatientChartProvider = PatientChartContext.Provider;
